import {BaseError} from './BaseError';

export class PreconditionError extends BaseError {
}

export class Preconditions {
  static checkPositive(value: number) {
    if (value < 0) {
      throw new PreconditionError('Value needs to be positive');
    }
  }

  static checkNotNull(value: any) {
    if (value === null || value === undefined) {
      throw new PreconditionError('Value must not be null or undefined.');
    }
  }

  static checkInstanceOf(value: any, klass: any) {
    if (!(value instanceof klass)) {
      throw new PreconditionError(`Value must be instance of ${klass}.`);
    }
  }

  static checkTypeOf(value: any, type: string) {
    if (typeof value !== type) {
      throw new PreconditionError(`Value must be type of ${type}.`);
    }
  }

  static checkNotEmpty(value: Array<any> | string) {
    if (value.length === 0) {
      throw new PreconditionError('Value must not be empty.');
    }
  }
}
